import { useMemo } from 'react';
import type { PlannedEmployeeWeek } from '@functieloonhuis/shared';
import { toDateString } from '../utils/dateUtils';

interface PlanningStatsProps {
  planned: PlannedEmployeeWeek[];
}

export function PlanningStats({ planned }: PlanningStatsProps) {
  const stats = useMemo(() => {
    const todayStr = toDateString(new Date());

    let kantoor = 0;
    let thuis = 0;
    let vrij = 0;

    for (const emp of planned) {
      const todayEntry = emp.days.find(d => d.date === todayStr);
      if (!todayEntry || todayEntry.isHoliday || !todayEntry.isWorkday) {
        vrij++;
      } else if (todayEntry.location === 'kantoor') {
        kantoor++;
      } else if (todayEntry.location === 'thuis') {
        thuis++;
      }
    }

    return { kantoor, thuis, vrij, total: planned.length };
  }, [planned]);

  if (stats.total === 0) return null;

  return (
    <div className="grid grid-cols-3 gap-4">
      <div className="bg-green-50 p-3 rounded-lg border border-green-200 text-center">
        <p className="text-2xl font-bold text-green-700">{stats.kantoor}</p>
        <p className="text-xs text-green-600">Op kantoor vandaag</p>
      </div>
      <div className="bg-blue-50 p-3 rounded-lg border border-blue-200 text-center">
        <p className="text-2xl font-bold text-blue-700">{stats.thuis}</p>
        <p className="text-xs text-blue-600">Thuis vandaag</p>
      </div>
      <div className="bg-gray-50 p-3 rounded-lg border border-gray-200 text-center">
        <p className="text-2xl font-bold text-gray-700">{stats.vrij}</p>
        <p className="text-xs text-gray-500">Vrij vandaag</p>
      </div>
    </div>
  );
}
